import * as Yup from 'yup'

const createAnnouncementSchema = Yup.object().shape({
    title: Yup.string().required('Required'),
    location: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
    link: Yup.string()
        .trim()
        .nullable()
        .test('is-url-valid', 'Enter a correct URL', function (value) {
            const urlRegex =
                /^(https?:\/\/)?([a-zA-Z0-9.-]+(:[a-zA-Z0-9.-]+)?@)?(www\.)?([a-zA-Z0-9.-]+)(\.[a-zA-Z]{2,})(:\d+)?(\/[^\s]*)?(\?[^\s]*)?(#[^\s]*)?$/

            // Only validate if value is not empty
            if (!value || value.trim() === '') {
                return true
            }

            // Validate against the regex
            return urlRegex.test(value)
        }),
})
export { createAnnouncementSchema }
